$(document).ready(function (){
    $("#table-permisos").DataTable({
        proccesing: true,
        serverSide: true,
        language: {
            url: "https://cdn.datatables.net/plug-ins/2.0.3/i18n/es-ES.json"
        },
        responsive: true,
        ajax: 'get-permissions',
        columns: [
            {data: 'id', name: 'id'},
            {data: 'name', name: 'name'},
        ],
        "columnDefs": [{
            "targets": 1,
            "data": "download_link",
        }]
    });

    $("#add-permiso").on('click',function (e){
        e.preventDefault()
        $("#form-permisos")[0].reset()
        $(".item-id").val('');
        $("#modal-title-permisos").text('Nuevo permiso')
        $("#modal-permisos").modal('show')
    })

    $("#form-permisos").on('submit', function (e) {
        e.preventDefault()
        let data = new FormData(this)
        $(".loader_").addClass("loading")
        sendData(data, 'add-permissions', 'modal-permisos')
    })

    function sendData(data, route, modal) {
        $.ajax({
            url: route,
            type: "post",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    if (data.type == "success") {
                        alertSuccess(data.msg)
                        $("#table-permisos").DataTable().ajax.reload();
                        $("#modal-permisos").modal('hide')
                    } else {
                        alertError(data.msg)
                    }
                }, 1000)

            },
            error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                /*var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });*/
            }
        })
    }

})
